import collectionInboxReducer from "./collectionInboxReducer";
import assessmentReviewInboxReducer from "./assessmentReviewInboxReducer";
import documentInboxReducer from "./documentInboxReducer";
import inspectionArrangementInboxReducer from "./inspectionArrangementInboxReducer";
import inspectionInboxReducer from "./inspectionInboxReducer";
import registrationInboxReducer from "./registrationInboxReducer";
import assessmentDecisionInboxReducer from "./assessmentDecisionInboxReducer";

const inboxReducers = {
    registrationInbox: registrationInboxReducer,
    collectionInbox: collectionInboxReducer,
    documentInbox: documentInboxReducer,
    inspectionArrangementInbox: inspectionArrangementInboxReducer,
    inspectionInbox: inspectionInboxReducer,
    assessmentReviewInbox: assessmentReviewInboxReducer,
    assessmentDecisionInbox: assessmentDecisionInboxReducer,
}

export default inboxReducers;